import type { Tables } from "./store";

/**
 * What this project calls a milestone: "Update" for a live game, "Milestone" in development,
 * or whatever a producer renamed the type to. The app's labels follow it.
 */
export function milestoneWord(t: Tables, spaceId: string): string {
  for (const k of t.kinds.values()) if (k.spaceId === spaceId && k.key === "phase") return k.name;
  return "Milestone";
}

export const plural = (word: string) => (/s$/i.test(word) ? word : `${word}s`);
export const lower = (word: string) => word.toLowerCase();
